module.exports = __webpack_public_path__ + "img/5.4c53d654.jpg";